import PageNotFound from '@pages/PageNotFound/PageNotFound';
import React, { Component, ErrorInfo } from 'react';

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<
  { children: React.ReactNode },
  State
> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error) {
    // Update state to indicate error
    console.error('Error caught by ErrorBoundary:', error);
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // Log error to an error reporting service if needed
    console.error('Error caught by ErrorBoundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Fallback UI
      return <PageNotFound />;
    }

    return this.props.children; // Render children if no error
  }
}
